import React from 'react';
// Data
import {
  sessionsPageAdditionalMeta,
  sessionsPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import SessionsPageMainContainer from '../../components/sessions/SessionsPageMainContainer';

function SessionsPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Sessions with Lady Cinder'
        desc='Step into the shadows with Lady Cinder — neon-gothic dominatrix, hypnotic goddess, and fire deity. Explore her signature hypnosis, mindfuck rituals, sensual sadism, and indoctrination sessions both online and in person.'
        keywords='Lady Cinder, Los Angeles dominatrix, neon gothic femdom, hypnosis sessions, mindfuck rituals, indoctrination play, sensual sadism, online dominatrix, goddess worship, fire performance'
        additionalMeta={sessionsPageAdditionalMeta}
        structuredData={sessionsPageStructuredData}
      />

      {/* Page */}
      <div className='grid overflow-hidden text-colour1 dark:text-colour1 min-h-screen bg-colour2 dark:bg-colour2 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />
          <header className='grid py-10 px-6 text-center gap-4 place-items-center'>
            <h1 className='neon_text_heavy_redpink font-titleFont text-4xl md:text-6xl tracking-wider drop-shadow-lg'>
              SESSIONS & SERVICES
            </h1>
            <p className='max-w-2xl text-base md:text-lg leading-relaxed'>
              "A seasoned Dominatrix, ritual performer, and erotic educator.” She
              specializes in transforming desire into art and discipline into
              devotion. Available for private sessions, immersive
              demonstrations, and curated BDSM education. Her expertise spans
              rope, psychological dominance, impact play, ritual theatre, and
              sensual control
            </p>
          </header>

          {/* Main page content */}
          <SessionsPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default SessionsPage;
